import React, { useEffect, useState } from "react";
import TrustedCompanies from "../../components/TrustedCompanies";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AboutUs() {
  const [t, i18n] = useTranslation("global");
  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/about_us`, {
          headers: {
            "Accept-Language": i18n.language,
          },
        });
        const result = await response.json();
        if (result && result.data && result.data.length > 0) {
          setAboutData(result.data[0]);
        }
      } catch (error) {
        console.error("Failed to fetch about data:", error);
      }
    };

    fetchAboutData();
  }, [i18n.language]);

  return (
    <>
      <div className="custom-section">
        <div className="container">
          <h1 className="mb-1 ">{t("about.title")}</h1>
          <h6 className="m-0 ">
            <Link className="link-hover" to="/">
              {t("about.home")}
            </Link>
            <span> - </span>
            <span className="second-color">{t("about.title")}</span>
          </h6>
        </div>
      </div>

      <section className="container my-5">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6 mb-3">
            <h1 style={{ display: "inline" }} className="main-color my-4 ">
              {aboutData?.main_title || t("about.heading")}
            </h1>
            <span>
            <img
              src={aboutData?.logo || "assets/imgs/Frame 1410103777.svg"}
             style={{width : "100px", borderRadius : "10px", margin : "0 5px"}}
              alt="About Us"
            />            </span>
            <p className="paragraph-color my-3 ">
              {aboutData?.main_description || t("about.subheading")}
            </p>

            <div className="d-flex justify-content-between gap-2 my-4">
              <div style={{ borderTop: "4px solid #DEC014", width: "250px" }}>
                <h5 className="main-color mt-2">{aboutData?.title_one || t("about.years")}</h5>
                <p className="paragraph-color">{aboutData?.description_one || t("about.yearsDesc")}</p>
              </div>
              <div style={{ borderTop: "4px solid #DEC014", width: "250px" }}>
                <h5 className="main-color mt-2">{aboutData?.title_two || t("about.students")}</h5>
                <p className="paragraph-color">{aboutData?.description_two || t("about.studentsDesc")}</p>
              </div>
            </div>

            <div className="d-flex justify-content-between gap-2 my-4">
              <div style={{ borderTop: "4px solid #DEC014", width: "250px" }}>
                <h5 className="main-color mt-2">{aboutData?.title_three || t("about.years")}</h5>
                <p className="paragraph-color">{aboutData?.description_three || t("about.yearsDesc")}</p>
              </div>
              <div style={{ borderTop: "4px solid #DEC014", width: "250px" }}>
                <h5 className="main-color mt-2">{aboutData?.title_four || t("about.students")}</h5>
                <p className="paragraph-color">{aboutData?.description_four || t("about.studentsDesc")}</p>
              </div>
            </div>
          </div>

          <div className="col-md-12 col-lg-6 mb-3">
            <img
              src={aboutData?.image || "assets/imgs/Frame 1410103777.svg"}
              width="100%"
              alt="About Us"
            />
          </div>
        </div>
      </section>

      <section className="container my-5">
        <h3 className="main-color my-3 text-center">{t("about.ourService")}</h3>

        <div className="d-flex flex-column flex-md-row align-items-center justify-content-center text-center">
          {[ 
            { img: "assets/imgs/Branding.svg", name: t("about.branding") },
            { img: "assets/imgs/Ui Design.svg", name: t("about.ui") },
            { img: "assets/imgs/Product.svg", name: t("about.product") },
          ].map((service, index) => (
            <div key={index} className="m-3">
              <img src={service.img} alt="" />
              <h4 className="main-color my-1">{service.name}</h4>
              <p className="main-color">{t("about.serviceDesc")}</p>
            </div>
          ))}
        </div>
      </section>

      <TrustedCompanies />
    </>
  );
}
